import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=1ef1ddfd"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"
import style0 from "./iframe.vue?vue&type=style&index=0&id=1ef1ddfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports